import React from "react"
import { AmplitudeEvents } from "../types/amplitudeEvents"
import { sendAmplitudeData } from "../utils/amplitude"
import { startMixerHandler } from "../utils/startMixerFunction"
import { MIXERS } from "./MixersSection"

interface IMixerTag {
  name: string
  icon: JSX.Element
}

export interface IMixerCard {
  name: string
  description: string
  tags: IMixerTag[]
  color: string
  textColor: string
  icon?: JSX.Element
  theme?: "WHITE" | "BLACK"
  templateCode?: string
}

interface ExtraMixerProps {
  rotate: string
  firstCardRef: React.RefObject<HTMLDivElement>
  lastCardRef: React.RefObject<HTMLDivElement>
  cardIndex: number
  setIsModalVisible: AsyncGeneratorFunction
}

const MixerCard: React.FC<IMixerCard & ExtraMixerProps> = ({
  name,
  description,
  tags,
  color,
  textColor,
  icon,
  theme = "WHITE",
  rotate,
  firstCardRef,
  lastCardRef,
  cardIndex,
  templateCode,
  setIsModalVisible,
}) => {
  const [hovered, setHovered] = React.useState(false)

  return (
    <div
      className="mixer-card"
      style={{
        background: `var(${color})`,
        color: theme === "WHITE" ? "#fff" : "var(--theme-black)",
        transform: `rotate(${hovered ? "0" : rotate}deg)`,
        transition: "transform 0.3s ease-in-out",
        zIndex: hovered ? 1 : 0,
        marginRight: cardIndex === MIXERS.length - 1 ? "16px" : "0",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      ref={
        cardIndex === 0
          ? firstCardRef
          : cardIndex === MIXERS.length - 1
          ? lastCardRef
          : null
      }
    >
      <div className="mixer-card-body">
        <div className="mixer-card-header h3Text">
          {icon ? (
            icon
          ) : (
            <div
              className="mixer-card-icon"
              style={{
                background: theme === "WHITE" ? "#fff" : "var(--theme-black)",
              }}
            ></div>
          )}
          <div className="mixer-card-name">{name}</div>
        </div>
        <div className="mixer-card-description" style={{ color: textColor }}>
          {description}
        </div>
        <div className="mixer-card-tags">
          {tags.map((tag, index) => (
            <MixerCardTag name={tag.name} icon={tag.icon} key={index} />
          ))}
        </div>
        <div
          className={`mixer-tag-start body-txt ${
            theme === "WHITE"
              ? "mixer-tag-start-white"
              : "mixer-tag-start-black"
          }`}
          style={{ color: textColor }}
          onClick={() =>
            startMixerHandler(
              templateCode,
              AmplitudeEvents.START_MIXER_FROM_MIXERS_SECTION,
              setIsModalVisible
            )
          }
        >
          Start mixer
        </div>
      </div>
    </div>
  )
}

const MixerCardTag: React.FC<IMixerTag> = ({ name, icon }) => {
  return (
    <div className="mixer-card-tag pText">
      <div
        style={{ marginRight: "7px", display: "flex", alignItems: "center" }}
      >
        {icon}
      </div>
      <div>{name}</div>
    </div>
  )
}

export default MixerCard
